import { render, staticRenderFns } from "./User.vue?vue&type=template&id=5e494fbc&scoped=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"
import style0 from "./User.vue?vue&type=style&index=0&id=5e494fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e494fbc",
  null
  
)

export default component.exports